import { render } from "./index.vue?vue&type=template&id=9196b34e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9196b34e&scoped=true&lang=css"

import exportComponent from "/Users/chencheng/code/bethlehem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9196b34e"]])

export default __exports__